<script setup lang="ts">
import imageAppleBlack from '@features/apps/assets/footer-apple-black.webp'
import imageGooglePlayBlack from '@features/apps/assets/footer-google-play-black.webp'
import imageHuaweiBlack from '@features/apps/assets/footer-huawei-black.webp'
import { useDownloadTracking } from '@features/apps/composables/useDownloadTracking'
import { APPS_ROUTES } from '@features/apps/constants'
import { useResponsive } from '@shared/nuxt/useResponsive'

type Props = {
  isShowFullText?: boolean
}

const props = defineProps<Props>()

const { isDesktop } = useResponsive()
const { trackCtaMobile } = useDownloadTracking()
</script>

<template>
  <the-button
    variant="tertiary"
    :href="APPS_ROUTES.landing"
    target="_blank"
    title="Скачать приложение Farfor"
    @click="trackCtaMobile"
  >
    <span data-test-id="button-text">
      <span v-if="isDesktop && !props.isShowFullText">Скачать</span>
      <span v-else>Скачать приложение</span>
    </span>

    <template #append>
      <nuxt-img
        width="16"
        height="16"
        :src="imageAppleBlack"
        alt="IOS"
        data-test-id="apple-icon"
      />
      <nuxt-img
        width="16"
        height="16"
        :src="imageGooglePlayBlack"
        alt="GooglePay"
        data-test-id="google-icon"
      />
      <nuxt-img
        width="16"
        height="16"
        :src="imageHuaweiBlack"
        alt="Huawei"
        data-test-id="huawei-icon"
      />
    </template>
  </the-button>
</template>
